import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  list(filter) {
    return Api()
      .get('/otatokens', {params: removeEmptyParams(filter)})
      .then((res) => res.data);
  },
  otaToken(id) {
    return Api()
      .get('/otatoken/' + id)
      .then((res) => res.data);
  },
  create(otaToken) {
    return Api()
      .post('/otatoken', otaToken)
      .then((res) => res.data);
  },
  update(otaToken) {
    return Api()
      .put('/otatoken/' + otaToken.id, otaToken)
      .then((res) => res.data);
  },
  delete(otaToken) {
    return Api()
      .delete('/otatoken/' + otaToken.id)
      .then(() => otaToken);
  },
  details(id) {
    return Api()
      .get('/otatoken/' + id + '/details')
      .then((res) => res.data);
  },
  availableAccommodations(id) {
    return Api()
      .get('/otatoken/' + id + '/available-accommodations')
      .then((res) => res.data);
  },
  migrate(id, data) {
    return Api()
      .post('/otatoken/' + id + '/migrate', data)
      .then((res) => res.data);
  },
  syncCount(id, type) {
    return Api()
      .get('/otatoken/' + id + '/sync/' + type + '/count')
      .then((res) => res.data);
  },
  sync(id, type) {
    return Api()
      .post('/otatoken/' + id + '/sync/' + type)
      .then((res) => res.data);
  },
};
